import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children"];
import React from 'react';
import Link from '@atlaskit/link';
import { CONTENT_URL_AI } from '../../../../../constants';
var AILearnMoreAnchor = function AILearnMoreAnchor(_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Link, _extends({
    href: CONTENT_URL_AI,
    target: "_blank",
    rel: "noopener noreferrer"
  }, props), children);
};
export default AILearnMoreAnchor;